<form name="form" (ngSubmit)="form.valid && submit()" novalidate #form="ngForm">
    <div class="modal-header">
        <h3 class="modal-title" id="modal-page-fix-title" translate>
            Use PageCorrect to fix these image sources
        </h3>
    </div>
    <div class="modal-body bg-white page-fix-form-fix" id="modal-page-fix">
        <div class="page-fix-form-fix-acc-edit-alt-text">
            <mon-spinner [loading]="loading">
                <p [innerHTML]="informationText"></p>

                <div *ngIf="!loading && urls.length > 0">
                    <div class="bg-light-grey d-flex align-items-stretch img-rounded mb-3 px-4 py-4">
                        <div class="flex-fill">
                            <div class="form-group row">
                                <label class="col-48 control-label" [attr.for]="'pf_value'" translate>
                                    Please insert the missing ALT text:
                                </label>
                                <div class="col-auto flex-fill">
                                    <input [attr.id]="'pf_value'" class="form-control" type="text" required
                                           [(ngModel)]="altText" name="altText"/>
                                </div>
                            </div>
                        </div>
                        <div class="pl-3 pt-5">
                            <img class="edit-image-thumbnail" [src]="imgThumbnail"
                                 [attr.alt]="altText"/>
                        </div>
                    </div>

                    <p class="font-weight-300 font-size-1-75" translate>Image sources that will be fixed</p>
                    <ul class="list-unstyled">
                        <li *ngFor="let url of urls" class="text-bold"><p>{{url}}</p></li>
                    </ul>
                </div>
                <div *ngIf="urls.length === 0" class="my-4 text-center text-grey">
                    <h4 translate>No Images matched with the provided Accessibility Snippet. The Acquia Web Governance Team has been
                        notified of this & will look in to it.</h4>
                </div>
            </mon-spinner>
        </div>
    </div>
    <div class="modal-footer">
        <button data-test="cancel-button" class="btn btn-border-radius btn-secondary" type="button" (click)="cancel()" translate>
            Cancel
        </button>
        <button data-test="save-button" class="btn btn-border-radius btn-marine-blue ml-0" [disabled]="form.invalid" translate>Save</button>
    </div>
</form>
